import { managerTimesheet } from "../../Api/managerTimesheet";
import {
  SAVE_MANAGER_MONTHDATA_REQUEST,
  SAVE_MANAGER_MONTHDATA_FAILURE,
  SAVE_MANAGER_MONTHDATA_SUCCESS
} from "../../Constants";

function requestSaveManagerTimesheet() {
  return {
    type: SAVE_MANAGER_MONTHDATA_REQUEST,

    isFetching: true
  };
}

function updateManagerTimesheetDataSuccess(data) {
  return {
    type: SAVE_MANAGER_MONTHDATA_SUCCESS,
    isFetching: false,
    message: data
  };
}

function updateManagerTimesheetError(errorMessage) {
  return {
    type: SAVE_MANAGER_MONTHDATA_FAILURE,
    isFetching: false,
    errorMessage
  };
}

export const updateManagerTimesheetData = payload => (dispatch, getState) => {
  dispatch(requestSaveManagerTimesheet());
  managerTimesheet
    .updateManagerTimesheetData(payload)
    .then(res => {
      dispatch(updateManagerTimesheetDataSuccess(res));
    })
    .catch(err => dispatch(updateManagerTimesheetError(err)));
};
export const resetAprroveMessage = payload => (dispatch, getState) => {
  dispatch(updateManagerTimesheetDataSuccess(""));
};

export const managerApproveTimesheetWeek = payload => dispatch => {
  dispatch(requestSaveManagerTimesheet());
  managerTimesheet
    .managerTimesheetWeek(payload)
    .then(res => {
      dispatch(updateManagerTimesheetDataSuccess(res));
    })
    .catch(err => dispatch(updateManagerTimesheetError(err)));
};
